import React, { use, useEffect, useImperativeHandle, useState } from "react";
import GoogleMap from "google-map-react";
import { ConfigProvider, Input } from "antd";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import StoreMapPopup from "./StoreMapPopup/StoreMapPopup";
import ReactDOMServer from "react-dom/server";

import StoreOpen from "../../assets/StoreOpen.svg";
import StoreClose from "../../assets/StoreClose.svg";
import SearchIcon from "../../assets/Search.svg";
import CurrentLocation from "../../assets/CurrentLocation.svg";
import Target from "../../assets/Target.svg";
import Add from "../../assets/Add.svg";
import Minus from "../../assets/Minus.svg";

import "./StoreCluster.scss";
import { useTranslation } from "react-i18next";

let marker: any;
let markerClusterer: any;
let markers: any = [];
let gmarkers: any = [];
const win: any = window;

const StoreCluster = ({ center, width, rtl, checked, storeData, mode, dispatch, handleAddress, ref }: any) => {
  const [mapApiLoaded, setMapApiLoaded] = useState(false);
  const [map, setMap] = useState<any>(null);
  const [maps, setMaps] = useState<any>(null);
  const [address, setAddress] = useState("");
  const [lat, setLat] = useState(center.lat);
  const [lng, setLng] = useState(center.lng);

  const { t } = useTranslation();

  useEffect(() => {
    if (maps !== null && map !== null) {
      handleAfterApiLoaded();
    }
  }, [map, maps]);

  useEffect(() => {
    if (maps !== null && map !== null) {
      addingMarkers();
    }
  }, [map, maps, storeData])

  const handleApiLoaded = (map: any, maps: any) => {
    setMapApiLoaded(true)
    setMap(map)
    setMaps(maps)
  };

  const handleAfterApiLoaded = () => {
    addMyLocationButton();
    if (width > 500) {
      customZoomInControl(map, maps);
    } else {
      map.setOptions({ zoomControl: false, mapTypeControl: false });
    }
    setCurrentLocation(false, maps);
    mapDoubleClickHandler(map, maps);
  }

  const mapDoubleClickHandler = (map: any, maps: any) => {
    maps.event.addListener(map, "dblclick", (e: any) => {
      setLat(e.latLng.lat())
      setLng(e.latLng.lng())
      const center = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
      }
      const geocoder = new maps.Geocoder();
      geocoder.geocode({ location: center }, (res: any, status: any) => {
        if (status === 'OK') {
          setAddress(res[0].formatted_address)
          handleAddressChange(res[0].formatted_address);
        }
      });
      setCurrentLocation(true);
    });
  };

  const customZoomInControl = (map: any, maps: any) => {
    var controlDiv = document.createElement("div");
    controlDiv.className = "map-zoomcontrol";
    var controlUI = document.createElement("button");
    controlUI.style.backgroundColor = "#008CFF";
    controlUI.style.border = "2px solid #008CFF";
    controlUI.style.border = "none";
    controlUI.style.outline = "none";
    controlUI.style.width = "40px";
    controlUI.style.height = "40px";
    controlUI.style.cursor = "pointer";
    controlUI.style.boxShadow = "0 1px 4px rgba(0,0,0,0.3)";
    controlDiv.appendChild(controlUI);

    // Set CSS for the control interior
    var controlText = document.createElement("div");
    controlText.style.backgroundImage = `url("${Add}")`;
    if (rtl) {
      controlText.style.width = "33px";
      controlText.style.height = "35px";
    } else {
      controlText.style.width = "30px";
      controlText.style.height = "35px";
    }
    controlText.style.backgroundSize = "18px 18px";
    controlText.style.backgroundPosition = "5px 9px";
    controlText.style.backgroundRepeat = "no-repeat";
    controlUI.appendChild(controlText);

    // Setup the click event listeners
    map.controls[maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
    controlUI.addEventListener("click", () => {
      map.setZoom(map.getZoom() + 1);
    });

    // Set CSS for the control border
    var controlUILeft = document.createElement("div");
    controlUILeft.style.backgroundColor = "#008CFF";
    controlUILeft.style.border = "none";
    controlUILeft.style.outline = "none";
    controlUILeft.style.cursor = "pointer";
    controlUILeft.style.textAlign = "center";
    controlUILeft.style.width = "40px";
    controlUILeft.style.height = "41px";
    controlDiv.appendChild(controlUILeft);

    // Set CSS for the control interior
    var controlTextLeft = document.createElement("div");
    controlTextLeft.style.backgroundImage = `url("${Minus}")`;
    controlTextLeft.style.height = "30px";
    controlTextLeft.style.backgroundSize = "18px 18px";
    controlTextLeft.style.backgroundPosition = "11px 11px";
    if (rtl) {
      controlTextLeft.style.width = "39px";
    } else {
      controlTextLeft.style.width = "30px";
    }
    controlTextLeft.style.backgroundRepeat = "no-repeat";
    controlTextLeft.style.borderBottomRightRadius = "4px"; 
    controlTextLeft.style.borderBottomLeftRadius = "4px";
    controlUILeft.appendChild(controlTextLeft);

    // Setup the click event listeners
    controlUILeft.addEventListener("click", () => {
      map.setZoom(map.getZoom() - 1);
    });
  };

  const addMyLocationButton = () => {
    if (map !== null && maps !== null) {
      var controlDiv = document.createElement("div");
      var firstChild = document.createElement("button");
      firstChild.style.backgroundColor = "#008CFF";
      firstChild.style.border = "none";
      firstChild.style.outline = "none";
      firstChild.style.width = "40px";
      firstChild.style.height = "40px";
      firstChild.style.borderRadius = "2px";
      firstChild.style.boxShadow = "0 1px 4px rgba(0,0,0,0.3)";
      firstChild.style.cursor = "pointer";
      firstChild.style.marginRight = "10px";
      firstChild.style.padding = "0px";
      firstChild.title = "Your Location";
      controlDiv.appendChild(firstChild);
      firstChild.style.marginBottom = "34px";

      var secondChild = document.createElement("div");
      secondChild.style.margin = "10px";
      secondChild.style.width = "18px";
      secondChild.style.height = "18px";
      secondChild.style.backgroundImage = `url("${Target}")`;
      secondChild.style.backgroundSize = "18px 18px";
      secondChild.style.backgroundPosition = "0px 0px";
      secondChild.style.backgroundRepeat = "no-repeat";

      secondChild.id = "you_location_img";
      firstChild.appendChild(secondChild);
      map.controls[
        maps.ControlPosition.RIGHT_BOTTOM
      ].push(controlDiv);

      firstChild.addEventListener("click", () => {
        setCurrentLocation(false);
      });
    }
  }

  const addingMarkers = () => {
    map.streetViewControl = false;

    //to clear the old cluster marker from map
    if (markerClusterer || checked) {
      var i = 0, l = markers.length;
      for (i; i < l; i++) {
        markers[i].setMap(null)
      }
       markers = [];
      if (markerClusterer) markerClusterer.clearMarkers();
    }

    const data = storeData.length > 0 && storeData.map((store: any) => {
      const icon = store.storeStatus.label.en.toLowerCase() === "open" ? StoreOpen : store.storeStatus.label.ar === "مفتوح" ? StoreOpen : StoreClose;
      return {
        ...store,
        center: {
          lat: store.latitude,
          lng: store.longitude,
        },
        icon: icon,
      };
    });

    const infowindow = new maps.InfoWindow({
      content: "",
      width: 200,
    });

    data.length > 0 && data.forEach((el: any) => {
      const clusterIcon = new maps.Marker({
        position: {
          lat: parseFloat(el.center.lat),
          lng: parseFloat(el.center.lng),
        },
        icon: el.icon,
        map,
        markerID: el.priority
      });

      gmarkers[el.priority] = clusterIcon;

      clusterIcon.addListener("click", () => {
        if (el.storeStatus.label.en.toLowerCase() === "open" || el.storeStatus.label.ar.toLowerCase() === "مفتوح") {
          const timeEn = el.openingHours.en.slice(el.openingHours.en.indexOf(":") + 1);
          const mapPopup = ReactDOMServer.renderToString(
            <StoreMapPopup
              places={rtl ? el.address.ar : el.address.en}
              time={rtl ? el.openingHours.ar : timeEn}
              status={rtl ? el.storeStatus.label.ar : el.storeStatus.label.en}
              ssk={el?.ssk}
              disabilityFriendly={el?.disabilityFriendly}
              type={"Store"}
              id={el.priority}
              rtl={rtl}
              mode={mode}
            />
          );

          infowindow.setContent(mapPopup);
          infowindow.open({
            anchor: clusterIcon,
            map: maps,
            shouldFocus: false,
          });

          maps.event.addListener(infowindow, "domready", function () {
            const btn: any = document.getElementById(`mpuButton${el.priority}`);
            if (btn !== null) {
              btn?.addEventListener("click", getDirectionClick);
            } else {
              btn?.removeEventListener("click", getDirectionClick);
            }
          });
        }
      });
      const getDirectionClick = () => {
        const origin = address.replaceAll(" ", "+");

        const str = `${el.address.en},${el.cityName}`;
        const destination = str.replaceAll(" ", "+");

        const directionUrl = `https://maps.google.com/maps/dir/${origin}/${destination}`;
        window.open(directionUrl, "_blank");
      }
      markers.push(clusterIcon);
    });


    markerClusterer = new MarkerClusterer({ markers, map })
    return markerClusterer
  };

  const handleAddressChange = (value: any) => {
    setAddress(value)
  };

  const handleSelect = async (value: any) => {
    const results = await geocodeByAddress(value);
    const latLng = await getLatLng(results[0]);
    setLat(latLng.lat)
    setLng(latLng.lng)
    setAddress(value)
    if (results.length > 0) {
      handleAddressChange(value);
      setCurrentLocation(true);
    }
  };
  useImperativeHandle(ref, () => ({
    listItemClick(index: any) {
      console.log('Clicked item:', index, maps, gmarkers);
      maps.event.trigger(gmarkers[index], 'click');
    }
  }));

  const setCurrentLocation = (isCordProvided: Boolean, mapData?: any) => {
    const mapsInfo = maps ?? mapData
    navigator.geolocation.getCurrentPosition((position) => {
      if (position.coords.latitude !== null && position.coords.longitude !== null && mapsInfo !== null) {
        
        if (!isCordProvided) {
          setLat(position.coords.latitude)
          setLng(position.coords.longitude)
          const latLng = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }

          const geocoder = new mapsInfo.Geocoder();
          geocoder.geocode({ location: latLng }, (res: any, status: any) => {
            if (status === 'OK') {
              setAddress(res[0].formatted_address)
              handleAddressChange(res[0].formatted_address);
            }
          });
        }

        const geocoder = new mapsInfo.Geocoder();
        
        geocoder.geocode({
          location: {
            lat: parseFloat(lat),
            lng: parseFloat(lng),
          },
        }, (results: any, status: any) => {
          const myLatlng = {
            lat: lat,
            lng: lng,
          };
          map.setZoom(13);

          userLocationMarkerSet(myLatlng, address)
          
          if (status === "OK") {
            if (results[0]) {
              results[0].address_components.map((item: any) => {
                if (item.types.includes("locality")) {
                  handleAddress(myLatlng, item.long_name);
                }
                return '';
              });
              dispatch({ type: "SET_LOADER", payload: false });
            }
          } else {
            dispatch({ type: "SET_LOADER", payload: false });
          }
        }
        );
      }
    }, (error) => {
      handleAddress(center, 'all');
      map.setZoom(5);
      userLocationMarkerSet(center, address)
      dispatch({ type: "SET_LOADER", payload: false });
    }
    );
  }

  const onSearchClick = () => {
    if (address.length > 0) {
      setCurrentLocation(true);
    }
  }

  const userLocationMarkerSet = (myLatlng: any, address: any) => {
    if (map) {
      map.setCenter(myLatlng);

      if (marker) {
        marker.setMap(null);
      }

      marker = new maps.Marker({
        position: myLatlng,
        icon: CurrentLocation,
      });

      const infowindow = new maps.InfoWindow({
        content: "",
        width: 200,
      });

      marker.addListener("click", () => {
        const mapPopup = ReactDOMServer.renderToString(
          <StoreMapPopup
            places={address}
            time={""}
            status={""}
            type={"currentLocation"}
            rtl={rtl}
          />
        );
        infowindow.setContent(mapPopup);
        infowindow.open({
          anchor: marker,
          map: maps,
          shouldFocus: false,
        });
      });

      marker.setMap(map);
    }
  }

  const getPlaceAutoComplete = () => {
    const classNameInput = rtl ? 'checkmap__inputField Map-right' : 'checkmap__inputField Map-left';
    const classNameSuggestion = rtl ? 'checkmap__suggestion sugg-right' : 'checkmap__suggestion sugg-left';
    if (mapApiLoaded) {
      return (
        <PlacesAutocomplete
          value={address}
          onSelect={handleSelect}
          onChange={handleAddressChange}
          searchOptions={{ componentRestrictions: { country: ["sa"] } }}
        >
          {({
            getInputProps,
            suggestions,
            getSuggestionItemProps,
            loading,
          }) => (
            <>
              <ConfigProvider direction={rtl ? "rtl" : "ltr"}>
                <div className={classNameInput}>
                  <div className="inputSection__withIcon" style={{ direction: rtl ? "rtl" : "ltr" }}>
                    <Input
                      className={rtl ? "input-section mapInput-right" : "input-section mapInput-left"}
                      {...getInputProps({ placeholder: t("Search") })}
                    />
                    <img src={SearchIcon} alt="icon" onClick={onSearchClick} style={rtl ? { left: "35px" } : { right: "30px" }} />
                  </div>
                </div>
              </ConfigProvider>

              <div className={classNameSuggestion}>
                {loading && <div style={{ textAlign: rtl ? 'right' : 'left' }}>Loading...</div>}
                {suggestions.map((suggestion, index) => {
                  const style: React.CSSProperties = {
                    backgroundColor: suggestion.active ? "#C3CED0" : "#fff",
                    cursor: "pointer",
                    display: loading ? "none" : "block",
                    padding: "5px 24px",
                    textAlign: rtl ? 'right' : 'left'
                  };

                  return (
                    <div {...getSuggestionItemProps(suggestion, { style })} key={index}>
                      {suggestion.description}
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </PlacesAutocomplete>
      )
    } else {
      return <></>;
    }
  }

  return (
    <React.Fragment>
      {getPlaceAutoComplete()}
      <div className="googlemap__container" id="googleMaps">
        <GoogleMap
          bootstrapURLKeys={{ key: win['googleMapKey'], language: win['lang'], libraries: ['places'] }}
          defaultCenter={center}
          defaultZoom={10}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }: any) => {
            handleApiLoaded(map, maps);
          }}
          options={{ streetViewControl: true }}
        />
      </div>
    </React.Fragment>
  )
}

export default StoreCluster;
